export default __webpack_public_path__ + "static/Technology-691af3d3c343a0eebd310ad60def2502.png";